import * as SG from 'styles';

import { Loader } from 'components/Loader';

import { TechnicalData } from '../TechnicalData';
import { useColorsList } from './ColorsList.hooks';
import * as S from './ColorsList.styles';

type ColorsListProps = {
  isGridChangeSet: Function;
};

export function ColorsList(props: ColorsListProps): React.ReactElement {
  const { isGridChangeSet } = props;

  const { productComponents, isLoading, technicalData, language } =
    useColorsList(isGridChangeSet);

  return (
    <Loader isLoading={isLoading}>
      <SG.Inner>
        <S.Wrapper>{productComponents}</S.Wrapper>
      </SG.Inner>

      {technicalData ? (
        <TechnicalData
          desc={
            language === 'en'
              ? technicalData?.englishDescription
              : technicalData?.italianDescription
          }
          accessories={
            language === 'en'
              ? technicalData?.englishAccessories
              : technicalData?.italianAccessories
          }
          sizes={technicalData?.sizeMinQtyPrice}
          technologies={technicalData?.technologiesImages}
          scale={technicalData.scale}
        />
      ) : undefined}
    </Loader>
  );
}
